import React from 'react';
export const CFIconPlus = {
    alias: 'plus',
    defaultTitle: 'Plus',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M19 11h-6V5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2Z' }))),
};
